export default "__VITE_ASSET__DRxo1gxb__"